export default __webpack_public_path__ + "static/uruk-c708ffd7200e7b1a96a0d2edc3a16747.jpg";